import React from 'react'
import ProductForm from '../components/ProductForm'

const NewProduct = () => {
    return (
        <div className='container'>
            <ProductForm/>
        </div>
    )
}

export default NewProduct